import { render, staticRenderFns } from "./Setting6.vue?vue&type=template&id=bcfeca1a&"
import script from "./Setting6.vue?vue&type=script&lang=js&"
export * from "./Setting6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports